<div class="popup-overlay" (click)="closePopup()">
  <div class="popup-container" (click)="$event.stopPropagation()">
    <div class="close-button-container">
      <ion-icon name="close-circle" (click)="closePopup()" class="close-icon"></ion-icon>
    </div>
    
    <div class="image-container" (click)="onImageClick()">
      <img *ngIf="popUpImageUrl" [src]="popUpImageUrl" alt="Promotion" class="promotion-image" />
    </div>
  </div>
</div>

